import { useAuth } from 'components/AuthProvider'
import { PaymentsProvider } from 'components/PaymentsProvider'
import { dashboardPath } from 'components/Routes'
import { REVIEW_ORDER_EXPIRED, TRADING_IS_PAUSED } from 'constants/index'
import { useReviewOrder } from 'hooks/useTrading'
import queryString from 'query-string'
import { useEffect, useState } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import PauseTrading from '../PauseTrading/PauseTrading'
import ReviewPurchase from './ReviewPurchase'
import ReviewSale from './ReviewSale'

export default function Review(): JSX.Element {
  const { reviewOrderId } = useParams<{ reviewOrderId: string }>()
  const { setToast } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const [tradingPaused, setTradingPaused] = useState<boolean>(false)

  const { type, productId } = queryString.parse(location.search) as {
    type?: string
    productId?: string
  }

  const {
    data: reviewOrderData,
    isLoading: reviewOrderLoading,
    error
  } = useReviewOrder(reviewOrderId ? parseInt(reviewOrderId) : null)

  useEffect(() => {
    if (!error) return
    const err = error as { message?: string; errorStatus?: string }
    if (err?.errorStatus === TRADING_IS_PAUSED) {
      setTradingPaused(true)
    }
    setToast({
      open: true,
      message: err?.message ?? 'An error occurred',
      type: 'error',
      duration: 3000
    })
    if (err?.errorStatus === REVIEW_ORDER_EXPIRED) {
      navigate(dashboardPath())
    }
  }, [error, navigate, setToast])

  const renderReviewType = () => {
    if (type === 'buy') {
      return (
        <ReviewPurchase
          reviewOrderData={reviewOrderData}
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          reviewOrderId={reviewOrderId!}
          reviewOrderLoading={reviewOrderLoading}
          productId={Number(productId as string)}
        />
      )
    } else {
      return (
        <ReviewSale
          reviewOrderData={reviewOrderData}
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          reviewOrderId={reviewOrderId!}
          reviewOrderLoading={reviewOrderLoading}
        />
      )
    }
  }

  if (tradingPaused) {
    return <PauseTrading />
  }

  return <PaymentsProvider>{renderReviewType()}</PaymentsProvider>
}
